import { Link as RouterLink } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { numberWithCommas } from "../../../utils";
import { useExpiringPricePeriodCount } from "../../../utils/hooks/useExpiringPricePeriodCount";
import { pricePeriodListPath } from "../shared/constants";
import { EXPIRING_WINDOW_DAYS } from "./Periods/periodModel";

/**
 * The pricebook list's warning that price periods are about to end, with the way to the
 * overview that lists them. Nothing at all while none are, or for a role that cannot open it.
 */
export default function ExpiringPeriodBanner() {
  const expiringCount = useExpiringPricePeriodCount();
  if (expiringCount <= 0) return null;

  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        <Button
          component={RouterLink}
          to={pricePeriodListPath("expiring")}
          color="inherit"
          size="small"
        >
          ดูราคาตามช่วงเวลา
        </Button>
      }
    >
      มี {numberWithCommas(expiringCount)} ช่วงราคาจะหมดภายใน{" "}
      {EXPIRING_WINDOW_DAYS.DEFAULT} วัน หมดช่วงแล้วสินค้าจะกลับไปขายที่ราคาหลัก
    </Alert>
  );
}
